import {player_api,campaign_manager_api} from '../window';
const configuration = {
  playerApiUrl: `${player_api}/api`,
  accountApiUrl: player_api,
  campaignManagerApi: campaign_manager_api,
  };

export default configuration;
